import type { ReactNode } from 'react';
import styles from './FormSection.module.css';

export interface IFormSectionProps {
    children: ReactNode;
    isBorderLess?: boolean;
    isRequired?: boolean;
    title?: string;
    type: 'referral' | 'postit' | 'transparent';
}

export function FormSection(props: IFormSectionProps) {
    let className = styles.formsection;

    if (props.type) {
        className += ` has-background-${props.type}`;
    }
    if (props.type === 'transparent') {
        className += ` ${styles.transparent}`;
    }
    if (props.isBorderLess) {
        className += ` ${styles.isBorderLess}`;
    }

    return (
        <section className={className}>
            {props.title && props.isRequired ? (
                <FormSubHeader>
                    {props.title}
                    <span className="required">*</span>
                </FormSubHeader>
            ) : (
                <FormSubHeader>{props.title}</FormSubHeader>
            )}
            {props.children}
        </section>
    );
}

export function FormSubHeader(props: { children: ReactNode }) {
    return <h3 className={styles.formSubheader}>{props.children}</h3>;
}

FormSection.defaultProps = {
    type: 'transparent',
};
